module.exports = __webpack_public_path__ + "static/media/kingJude.ab45227b.JPG";